import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const groundwaterApi = createApi({
    reducerPath: "core/groundwater",
    baseQuery: axiosBaseQuery,
    tagTypes: ["groundwaterList"],
    endpoints: (builder) => ({
        groundwaterFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['groundwaterList'],
            query: (query = '') => ({
                url: "/core/groundwater" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        groundwaterCreate: builder.mutation({
            invalidatesTags: ['groundwaterList'],
            query: (data) => ({
                url: `/core/groundwater`,
                method: "POST",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        }),
        groundwaterUpdate: builder.mutation({
            invalidatesTags: ['groundwaterList'],
            query: (data) => ({
                url: `/core/groundwater/${data.get('id')}`,
                method: "PUT",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                } 
            })
        }),

        // console.log(data);

        groundwaterDelete: builder.mutation({
            invalidatesTags: ['groundwaterList'],
            query: (id) => ({ url: "/core/groundwater/" + id, method: "DELETE" })
        }),
    })
})

export const { useGroundwaterFindAllQuery, useGroundwaterCreateMutation, useGroundwaterUpdateMutation, useGroundwaterDeleteMutation } = groundwaterApi;
export { groundwaterApi };
